import React from "react";
import { Typography } from "@mui/material";
import { SampleDetailsType } from "src/common/types/sample";
import { getSampleDetailsSections } from "src/common/funcs/sampleDetailsFields";

export type SampleDetailsContentProps = {
  data: Partial<SampleDetailsType> | null;
  extended?: boolean;
  className?: string;
};

export const SampleDetailsContent = ({
  data,
  extended = false,
  className = "sample-details-container",
}: SampleDetailsContentProps) => {
  const sections = getSampleDetailsSections(data, extended);

  return (
    <div className={className}>
      {sections.map((section, index) => (
        <div key={index} className="sample-details-section">
          <Typography
            variant="h5"
            paragraph={false}
            className="sample-details-section-header"
          >
            {section.title}
          </Typography>
          <div className="sample-details-content">
            {section.fields.map((detail, index) => (
              <React.Fragment key={index}>
                <span>{detail.label}:</span>
                <span>{detail.value || ""}</span>
              </React.Fragment>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};
